"use client";
import { useState } from "react";
import { Box, Menu, X } from "lucide-react";

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);

    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className="fixed w-full bg-white z-50 shadow">
      
      {/* Top Navbar */}
      <div className="max-w-7xl mx-auto px-4 flex justify-between items-center h-16">

        {/* Logo */}
        <div
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => scrollToSection("hero")}
        >
          <img
            src="/beeboxlogo.png"
            alt="Beebox Logo"
            className="w-10 h-10 object-contain"
          />
          <span className="text-2xl font-bold">
            Beebox<span className="text-[#FFC33A]">3D</span>
          </span>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8 items-center font-medium">
          <button onClick={() => scrollToSection("products")} className="hover:text-[#FFC33A] transition">
            Products
          </button>
          <button onClick={() => scrollToSection("enterprise-platform")} className="hover:text-[#FFC33A] transition">
            Platform
          </button>
          <button onClick={() => scrollToSection("why-us")} className="hover:text-[#FFC33A] transition">
            Why Us
          </button>
          <button
            onClick={() => scrollToSection("signup")}
            className="bg-[#FFC33A] px-5 py-2 rounded-full font-semibold hover:scale-105 transition"
          >
            Start Free Trial
          </button>
        </div>

        {/* Mobile Toggle Button */}
        <button
          className="md:hidden"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="flex flex-col px-6 py-4 space-y-4 font-medium">
            
            <button
              onClick={() => scrollToSection("products")}
              className="text-left hover:text-[#FFC33A] transition"
            >
              Products
            </button>

            <button
              onClick={() => scrollToSection("enterprise-platform")}
              className="text-left hover:text-[#FFC33A] transition"
            >
              Platform
            </button>

            <button
              onClick={() => scrollToSection("why-us")}
              className="text-left hover:text-[#FFC33A] transition"
            >
              Why Us
            </button>

            <button
              onClick={() => scrollToSection("signup")}
              className="bg-[#FFC33A] py-3 rounded-full font-semibold"
            >
              Start Free Trial
            </button>

          </div>
        </div>
      )}

    </nav>
  );
}
